import { useMutation } from '@tanstack/react-query'
import { $fetch } from 'utils/fetch'

async function stopCall(callId) {
  const { data } = await $fetch(`/v1/calls/${callId}/stop`, {
    method: 'POST',
    body: { call_id: callId },
  })
  return data
}

export function useEndActiveCall(props) {
  return useMutation({
    mutationFn: async (callId) => {
      return await stopCall(callId)
    },
    ...props,
  })
}
